import React, { useState, useEffect, memo } from "react";

const Counter = ({ initialValue = 0, countFinish, ballRestart }) => {
  const [count, setCount] = useState(initialValue);

  useEffect(() => {
    setCount(initialValue);
  }, [initialValue, ballRestart]);

  useEffect(() => {
    if (count > 0) {
      const timer = setInterval(() => {
        setCount((prevCount) => prevCount - 1);
      }, 1000);

      return () => clearInterval(timer);
    }

    if (count === 0 && initialValue) {
      countFinish("ball start");
    }
  }, [count]);

  return (
    <>
      <span>{count}</span>
    </>
  );
};

export default memo(Counter);
